<template>
  <div v-if="!elementIsHidden"
       :data-id="contentElement.client_id"
       :data-type="contentElement.content_type"
       :class="[contentElementClasses]"
       class="fds"
  >
    <slot-array v-if="shouldShowLabel" :length="8">
      <template :slot="1">
        <column>
          <component :is="contentElement.labelTag" :class="contentElement.labelClass">
            {{contentElement.label_title}}
            <help-tooltip v-if="contentElement.help_text"
                          :text="contentElement.help_text"
                          :key="`${contentElement.client_id}-${contentElement.help_text}`"></help-tooltip>
          </component>
        </column>
      </template>
      <template :slot="2">

      </template>
    </slot-array>
    <component
      v-if="getComponentByType(contentElement.content_type)"
      :is="getComponentByType(contentElement.content_type)"
      :content-element="contentElement"
      :entry="entry"
      :is-in-edit-mode="isInEditMode"
      :showingAllAttachments="showingAllAttachments"
      :key="contentElement.client_id">
    </component>
    <slot-array :length="1">
      <template :slot="1">


      </template>
    </slot-array>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import {Hash} from "~/interfaces/hashInterfaces";
import DetailViewContentElementDefinition from "~/models/detailView/elements/detailViewContentElementDefinition";
import {DetailViewContentElementType} from "~/enums/detailViews/detailViewContentElementType";
import SlotArray from "~/components/layouts/slotArray.vue";
import DetailViewContentElementHeader from "./detail-view-content-element-header.vue"
import DetailViewContentElementPageTitle from "./detail-view-content-element-page-title.vue"
import DetailViewContentElementActions from "./detail-view-content-element-actions.vue"
import DetailViewContentElementPageSubtitle from "./detail-view-content-element-page-subtitle.vue"
import DetailViewContentElementModelProperty from "./detail-view-content-element-model-property.vue"
import DetailViewContentElementHeading from "./detail-view-content-element-heading.vue"
import DetailViewContentElementSubheading from "./detail-view-content-element-subheading.vue"
import DetailViewContentElementTextArea from "./detail-view-content-element-text-area.vue"
import DetailViewContentElementDivider from "./detail-view-content-element-divider.vue"
import DetailViewContentElementRelatedObject from "./detail-view-content-element-related-object.vue";
import DetailViewContentElementModelHistory from "./detail-view-content-element-model-history.vue"
import DetailViewContentElementFileProperty from "./detail-view-content-element-file-property.vue";
import DetailViewContentElementRelationSection from "./detail-view-content-element-relation-section.vue";
import DetailViewContentElementDocumentLink from "./detail-view-content-element-document-link.vue";
import DetailViewContentElementFormList from "./detail-view-content-element-form-list.vue";
import DetailViewContentElement from "~/models/detailView/elements/detailViewContentElement";
import LayoutElementGrid from "./layout-element-grid.vue"
import ObjectModelEntry from "~/models/objectModelEntries/objectModelEntry";
import HelpText from "~/components/helpText.vue"
import {DetailViewContentElementCapability} from "~/models/detailView/elements/detailViewContentElementCapability";
import DetailViewEditElementBase from "./detail-view-edit-element-base.vue"
import ObjectModelConditionalRuleEvaluator from "~/models/objectModels/objectModelConditionalRuleEvaluator";
export default Vue.extend({
    name: "detail-view-content-element-base",
    mixins: [],
    components: {
      'page-header': DetailViewContentElementHeader,
      'page-title': DetailViewContentElementPageTitle,
      'actions': DetailViewContentElementActions,
      'page-subtitle': DetailViewContentElementPageSubtitle,
      'model-property': DetailViewContentElementModelProperty,
      'heading': DetailViewContentElementHeading,
      'subheading': DetailViewContentElementSubheading,
      'text-area': DetailViewContentElementTextArea,
      'divider': DetailViewContentElementDivider,
      'related-object': DetailViewContentElementRelatedObject,
      'grid': LayoutElementGrid,
      'stack': LayoutElementGrid,
      'document-link': DetailViewContentElementDocumentLink,
      'model-history': DetailViewContentElementModelHistory,
      'form-list': DetailViewContentElementFormList,
      'file-property': DetailViewContentElementFileProperty,
      'relation-section': DetailViewContentElementRelationSection,
      "detail-view-edit-element-base": DetailViewEditElementBase,
      SlotArray,
      HelpText
    },
    props: {
      contentElement: {
        type: DetailViewContentElement
      },
      isInEditMode: {
        type: Boolean,
        default: false
      },
      entry: {
        type: ObjectModelEntry
      },
      showingAllAttachments: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        DetailViewContentElementCapability
      }
    },
    computed: {
      contentElementClasses(): Hash<boolean> {
        return {
          'dv-content-element': !this.disabled,
          [this.getComponentClass(this.contentElement.content_type)]: true,
        };
      },
      elementIsHidden(): boolean {
        // When in normal display mode, we rely on the backend to calculate which elements are hidden, because not all
        // property values may be sent to the frontend so we may not be able to calculate it correctly. But, in edit mode,
        // elements are expected to appear/disappear as values are edited and the conditional rules result changes.
        if (this.isInEditMode) {
          if (!this.entry) return false;
          const visible = ObjectModelConditionalRuleEvaluator.evaluate(this.entry, this.contentElement, 'visible');
          return !visible;
        } else {
          return this.entry?.view_data?.hidden_element_client_ids?.includes(this.contentElement.client_id);
        }
      },
      shouldShowLabel(): boolean {
        return this.contentElement.can(DetailViewContentElementCapability.labelable);
      },
    },
    methods: {
      getComponentByType(contentType: DetailViewContentElementType): string {
        return DetailViewContentElementDefinition.getComponent(contentType);
      },
      getComponentClass(contentType: DetailViewContentElementType): string {
        return DetailViewContentElementDefinition.getComponentClass(contentType);
      },
    },
  });
</script>